import axios from 'axios';
import router from '@/router'; // Stelle sicher, dass der korrekte Pfad für den Vue-Router importiert wird.

const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interzeptor für die Anfrage: Access-Token anhängen
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

let refreshPromise = null;

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response && error.response.status === 401) {
            const refreshToken = localStorage.getItem('refreshToken');

            // Wenn kein Refresh-Token existiert, sofort zum Login umleiten
            if (!refreshToken) {
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                router.push('/pages/login');
                return Promise.reject(error);
            }

            // Falls bereits ein Refresh läuft, warten und dann den neuen Token nutzen
            if (!refreshPromise) {
                refreshPromise = axios.post(
                    `${import.meta.env.VITE_API_BASE_URL}user-auth/token/refresh/`,
                    { refresh: refreshToken },
                    { headers: { 'Content-Type': 'application/json' } }
                )
                .then((response) => {
                    localStorage.setItem('accessToken', response.data.access);
                    return response.data.access;
                })
                .catch((err) => {
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('refreshToken');
                    router.push('/pages/login');
                    return Promise.reject(err);
                })
                .finally(() => {
                    refreshPromise = null;
                });
            }

            try {
                const newAccessToken = await refreshPromise;
                if (!newAccessToken) {
                    throw new Error('Kein neuer Access-Token erhalten');
                }

                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                return axiosInstance(originalRequest);
            } catch (err) {
                return Promise.reject(err);
            }
        }

        return Promise.reject(error);
    }
);

export default {
    install(app) {
        app.config.globalProperties.$axios = axiosInstance; // Für Options API
        app.provide('axios', axiosInstance); // Für Composition API
    },
};
